<script>
import {notificationMethods, productMethods} from "@/state/helpers";

import { required } from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Ürün Hareketleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {
      toastAction:'',
      toastMessage:'',
      showToast:false,
      itemsLoaded: false,
      items: [],
      product: {},
      productTransactions: [],
      title: "Ürün Hareketleri",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Ürünler",
          href:"/products"
        },
        {
          text: "Ürün Hareketleri",
          active: true,
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,

      addForm: {
        name: "",
        code: "",
        content: "",
        image: "",
        section: "",
      },

      totalRows: 1,

      page: 1,

      perPage: 20,

      pageOptions: [10, 25, 50, 100],
      filter: null,

      filterOn: [],

      sortBy: "createdAt",
      sortDesc: false,
      fields: [
        {
          key: "comment",
          label: "İşlem",
          sortable: true,
        },
        {
          key: "quantity",
          label: "Adet",
          sortable: false,
        },
        {
          key: "createdAt",
          label:"Oluşturulma Tarihi",
          sortable: true,
        },
      ],
    };
  },
  validations: {
    addForm: {
      comment:{required},
      quantity: { required },
    },
  },
  watch:{
    page(newPage){
      this.getProductTransactions(newPage);
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    this.getProduct();
    this.getProductTransactions();
  },
  methods: {
    ...productMethods,
    ...notificationMethods,

    getProductTransactions(page=this.page){
      this.itemsLoaded=false;
      this.fetchProductTransactions({productId: this.$route.params.productId ,page, limit:this.perPage}).then(res=>{
        this.totalRows = res.total;
        // getting category ready for fields
        this.items = res.docs.map(elem=>{
          return elem;
        })
        this.itemsLoaded=true;
      })
    },

    getProduct(){
      this.fetchProduct({id: this.$route.params.productId}).then(res=>{
        // getting category ready for fields
        this.product = res
      })
    },

    handleSubmit() {
      this.addSubmitted = true;
      this.$v.addForm.$touch();
      if (
          this.$v.addForm.$invalid || isNaN(this.addForm.quantity)
      ) {
        return;
      } else {
       this.createProductTransaction({productId: this.$route.params.productId,data: this.addForm}).then(()=>{
          this.toastMessage="İşlem başarıyla eklendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.showModal = false;
          this.getProductTransactions();
          this.getProduct();
          this.addForm.comment = "";
          this.addForm.quantity = "";
        })
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems" />
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row" v-if="itemsLoaded ">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">{{this.product.name}} ({{this.product.code}})</h4>

            <p
                class="text-muted mb-4"
            >{{this.product.content}}</p>
            <div class="table-responsive ">
              <table class="table table-nowrap mb-0">
                <tbody>
                <tr>
                  <th scope="row">Bakiye :</th>
                  <td>{{this.product.balance}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                </div>

                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showModal = true"
                >
                  Giriş/Çıkış Ekle
                </button>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="items"
                  :fields="fields"
                  responsive="sm"
              >
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal v-model="showModal" title="Kullanıcı Ekle" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="comment">İşlem Açıklaması</label>
                <input
                    id="comment"
                    type="text"
                    v-model="addForm.comment"
                    class="form-control"
                    placeholder="İşlem açıklaması giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.comment.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.comment.required"
                    class="invalid-feedback"
                >
                  İşlem Açıklaması girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="quantity">Adet</label>
                <input
                    id="quantity"
                    type="text"
                    v-model="addForm.quantity"
                    class="form-control"
                    placeholder="Adet Giriniz"
                    :class="{
                    'is-invalid': addSubmitted && ($v.addForm.quantity.$error || isNaN(addForm.quantity)),
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.quantity.required"
                    class="invalid-feedback"
                >
                  Adet girilmesi gerekli bir alandır.
                </div>
                <div
                    v-if="addSubmitted && $v.addForm.quantity.required && isNaN(addForm.quantity)"
                    class="invalid-feedback"
                >
                  Adet alanına sayı girilmelidir.
                </div>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kaydet</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div class="spinner-wrapper" v-else>
      <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
